import AssessmentServiceApi from "../../services/assessment-api";

const updateUserPlan = (data) => {
  return function () {
    return AssessmentServiceApi.updateUserPlan(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

export { updateUserPlan };
